import React from 'react'

const TiktokIcon = props => (
  <svg viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17 5.48001V7.48001C16.9986 7.61984 16.9409 7.7532 16.84 7.85001C16.7389 7.94092 16.6057 7.98772 16.47 7.98001C14.8358 7.87665 13.274 7.26869 12 6.24001V14C12 17.3137 9.31371 20 6 20C2.68629 20 0 17.3137 0 14C0 10.6863 2.68629 8.00001 6 8.00001C6.1832 7.99006 6.3668 7.99006 6.55 8.00001C6.80489 8.02088 7.00085 8.23427 7 8.49001V10.49C7.00104 10.6325 6.93876 10.768 6.83 10.86C6.72124 10.9577 6.57456 11.0017 6.43 10.98C6.28638 10.9767 6.1427 10.9834 6 11C4.34315 11 3 12.3432 3 14C3 15.6569 4.34315 17 6 17C7.65685 17 9 15.6569 9 14V0.500006C9 0.223864 9.22386 6.38427e-06 9.5 6.38427e-06H11.5C11.7577 -0.00128524 11.9742 0.193556 12 0.450006C12.2096 2.87077 14.1292 4.79038 16.55 5.00001C16.799 5.02487 16.9912 5.22995 17 5.48001Z"
      fill="currentColor"
    />
  </svg>
)

export default TiktokIcon
